/* eslint-disable */
import Keycloak from 'keycloak-js';

import { persistAuthSessionCredentials } from 'core/storage/authSessionStorage';

const _kc = new Keycloak('/keycloak.json');
const tokenSecondsExpiration = 1800;
/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */

const initKeycloak = (onAuthenticatedCallback: any) => {
  _kc
    .init({
      checkLoginIframe: false,
      //onLoad: 'login-required',
      onLoad: 'check-sso',
      // silentCheckSsoRedirectUri: window.location.origin,
      pkceMethod: 'S256',
    })
    .then((authenticated) => {
      if (authenticated) {
        const investmentOfficeId = _kc.tokenParsed?.investmentOfficeId ?? '';
        persistAuthSessionCredentials({
          accessToken: _kc.token || '',
          refreshToken: _kc.refreshToken || '',
          investmentOfficeId,
        });
      } else {
        console.warn('not authenticated!');
        doLogin();
      }
    })
    .catch((error) => {
      console.warn('not authenticated!');
      doLogin();
    });
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const getRefreshToken = () => _kc.refreshToken;

const updateToken = (successCallback: any) => {
  return _kc
    .updateToken(tokenSecondsExpiration)
    .then(successCallback)
    .catch(doLogin);
};

const getInvestmentOfficeId = () => _kc.tokenParsed?.investmentOfficeId || '';

const getUsername = () => _kc.tokenParsed?.preferred_username;

const getCurrentUser = () => _kc.tokenParsed;

export default {
  initKeycloak,
  doLogin,
  doLogout,
  getToken,
  getRefreshToken,
  updateToken,
  getUsername,
  getCurrentUser,
  getInvestmentOfficeId,
};
